export interface BciBrand {
  int_IdMarca: number;
  str_Marca: string;
  lst_Modelos: Array<{ int_IdModelo: number; str_modelo: string }>;
}

export interface BciRegion {
  int_Id: number;
  str_Nombre: string;
}

export interface BciCommune {
  int_Id: number;
  str_Nombre: string;
}

export interface BciDeductibleRate {
  int_IdDeducible: number;
  str_NombreDeducible: string;
  dbl_ValorDeducibleUF: number;
  dbl_PrimaBrutaUF: number;
  dbl_PrimaBrutaPesos: number;
  dbl_PrimaNetaUF: number;
  dbl_PrimaNetaPesos: number;
  dbl_CuotaPesos: number;
}

export interface BciProductQuotation {
  int_CodigoProducto: number;
  str_NombreProducto: string;
  int_NroTarificacion: number;
  lst_Deducibles: BciDeductibleRate[];
}

export interface BciQuotationResponse {
  str_NroCotizacion: string;
  lst_Productos: BciProductQuotation[];
  dt_InicioVigencia: string;
  dt_FinVigencia: string;
  int_CodigoError?: number;
  str_MensajeError?: string;
}

export interface BciProductInfo {
  tagline: string;
  targetClient: string;
  sellingPoint: string;
  highlights: string[];
  workshop: string;
  rcType: string;
}

export interface BciProductInfoResponse {
  products: Record<string, BciProductInfo>;
  commonExclusions: string[];
}

export interface BciVehicleDataResponse {
  str_Marca: string;
  str_Modelo: string;
  str_Color: string;
  str_Tipo: string;
  int_Ano: number;
  str_Motor: string;
  str_Chasis: string;
  dbl_Tasacion: number;
  int_CodMarcaBci: number;
  int_CodModeloBci: number;
}

export interface BciProposalResponse {
  bool_Estado: boolean;
  str_Propuesta: string; // PDF base64
  str_MensajeError?: string;
}

export interface BciVehicleData {
  licensePlate: string;
  brandId: number | null;
  brandName: string;
  modelId: number | null;
  modelName: string;
  year: number | null;
  vehicleType: 1 | 2; // 1=Usado, 2=Nuevo
  vehicleUsage: 1 | 2; // 1=Comercial, 2=Particular
  engine: string;
  chassis: string;
  color: string;
}

export interface BciInsuredData {
  rut: number | null;
  dv: string;
  rutFormatted: string;
  age: number | null;
  firstName: string;
  lastName: string;
  secondLastName: string;
  phone: string;
  email: string;
}

export interface BciContractorData {
  isSameAsInsured: boolean;
  rut: number | null;
  dv: string;
  rutFormatted: string;
  firstName: string;
  lastName: string;
  secondLastName: string;
  phone: string;
  email: string;
  regionId: number | null;
  communeId: number | null;
  address: string;
}

export interface BciInsuranceConfig {
  installmentCount: number;
  validityPeriod: 12 | 24 | 36;
  paymentMethod: 1 | 2 | 3 | 4; // PAC, PAT, Contado, Aviso Vencimiento
}

export interface BciQuoteMapping {
  quoteId: number;
  productCode: number;
  deductibleId: number;
}

export interface BciQuoteResult {
  quoteNumber: string;
  products: BciProductQuotation[];
  selectedProductCode: number | null;
  selectedDeductibleId: number | null;
  validityStartDate: string;
  validityEndDate: string;
  leadId: number | null;
  clientId: number | null;
  quoteMapping: BciQuoteMapping[];
}

export interface BciPolicyData {
  proposalPdf: string | null;
  paymentUrl: string | null;
  paymentTransactionId: string | null;
  paymentStatus: string | null;
  policyNumber: string | null;
  policyPdf: string | null;
}

export interface BciSegurosFormData {
  vehicle: BciVehicleData;
  insured: BciInsuredData;
  contractor: BciContractorData;
  insuranceConfig: BciInsuranceConfig;
  quoteResult: BciQuoteResult;
  policy: BciPolicyData;
}

export const initialBciSegurosFormData: BciSegurosFormData = {
  vehicle: {
    licensePlate: '',
    brandId: null,
    brandName: '',
    modelId: null,
    modelName: '',
    year: null,
    vehicleType: 1,
    vehicleUsage: 2,
    engine: '',
    chassis: '',
    color: '',
  },
  insured: {
    rut: null,
    dv: '',
    rutFormatted: '',
    age: null,
    firstName: '',
    lastName: '',
    secondLastName: '',
    phone: '',
    email: '',
  },
  contractor: {
    isSameAsInsured: true,
    rut: null,
    dv: '',
    rutFormatted: '',
    firstName: '',
    lastName: '',
    secondLastName: '',
    phone: '',
    email: '',
    regionId: null,
    communeId: null,
    address: '',
  },
  insuranceConfig: {
    installmentCount: 12,
    validityPeriod: 12,
    paymentMethod: 1,
  },
  quoteResult: {
    quoteNumber: '',
    products: [],
    selectedProductCode: null,
    selectedDeductibleId: null,
    validityStartDate: '',
    validityEndDate: '',
    leadId: null,
    clientId: null,
    quoteMapping: [],
  },
  policy: {
    proposalPdf: null,
    paymentUrl: null,
    paymentTransactionId: null,
    paymentStatus: null,
    policyNumber: null,
    policyPdf: null,
  },
};
